// Country list (English names) for nationality selection.
// English names keep compliance normalization (_cc_from_country) accurate server-side.
export const COUNTRIES = [
  "Germany", "Austria", "Switzerland", "Albania", "Bosnia and Herzegovina", "Bulgaria",
  "Croatia", "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Greece",
  "Hungary", "Ireland", "Italy", "Kosovo", "Latvia", "Lithuania", "Luxembourg",
  "Malta", "Moldova", "Montenegro", "Netherlands", "North Macedonia", "Norway",
  "Poland", "Portugal", "Romania", "Serbia", "Slovakia", "Slovenia", "Spain",
  "Sweden", "Turkey", "Ukraine", "United Kingdom", "Belgium", "Cyprus",
  "Afghanistan", "Algeria", "Bangladesh", "Brazil", "China", "Egypt", "Georgia",
  "India", "Indonesia", "Iran", "Iraq", "Morocco", "Nigeria", "Pakistan",
  "Philippines", "Russia", "Syria", "Tunisia", "United States", "Vietnam", "Other",
];
